import { AppConfigurationClient } from "@azure/app-configuration";

const appConfigurationClient = new AppConfigurationClient(process.env.REACT_APP_APP_CONFIG_CONNECTION_STRING);

export default appConfigurationClient;
